import { DataBean } from "../DataBean";

export class BusinessCore extends DataBean {

    public async getBusinessCoreCatalog(idBusinessCore: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBusinessCoreCatalog_Number", [idBusinessCore]);
    }

}
